import { memberData } from "../../../utilities/API/supertokenServices"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"

export const memberDataService = createAsyncThunk(
    'memberDataService', memberData
)

const initialState = {
    loader: false
}

const memberDataSlice = createSlice({
    name: 'memberDataService',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(memberDataService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(memberDataService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(memberDataService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})


export default memberDataSlice.reducer